module.exports = __webpack_public_path__ + "img/Gift.b16699cc.png";